import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { text, grey, secondary, info } = colors;
const { size } = typography;

const outlined = {
  base: {
    minHeight: pxToRem(32),
    color: text.main,
    borderColor: grey[300],
    backgroundColor: grey[50],
    borderRadius: pxToRem(4),
    padding: `${pxToRem(5)} ${pxToRem(16)}`,

    "&:hover": {
      backgroundColor: grey[100],
      borderColor: grey[400],
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: "rgba(15, 108, 189, 0.06)",
    borderColor: colors.primary.main,
    color: colors.primary.main,

    "&:hover": {
      backgroundColor: "rgba(15, 108, 189, 0.12)",
      borderColor: colors.primary.focus,
      color: colors.primary.focus,
    },
  },

  secondary: {
    backgroundColor: grey[50],
    borderColor: secondary.main,
    color: secondary.main,

    "&:hover": {
      backgroundColor: grey[100],
      borderColor: secondary.focus,
      color: secondary.focus,
    },
  },

  success: {
    backgroundColor: "rgba(4, 120, 87, 0.06)",
    borderColor: colors.success.main,
    color: colors.success.main,

    "&:hover": {
      backgroundColor: "rgba(4, 120, 87, 0.12)",
      borderColor: colors.success.focus,
      color: colors.success.focus,
    },
  },

  warning: {
    backgroundColor: "rgba(180, 83, 9, 0.06)",
    borderColor: colors.warning.main,
    color: colors.warning.main,

    "&:hover": {
      backgroundColor: "rgba(180, 83, 9, 0.12)",
      borderColor: colors.warning.focus,
      color: colors.warning.focus,
    },
  },

  error: {
    backgroundColor: "rgba(185, 28, 28, 0.06)",
    borderColor: colors.error.main,
    color: colors.error.main,

    "&:hover": {
      backgroundColor: "rgba(185, 28, 28, 0.12)",
      borderColor: colors.error.focus,
      color: colors.error.focus,
    },
  },

  info: {
    backgroundColor: "rgba(3, 105, 161, 0.06)",
    borderColor: info.main,
    color: info.main,

    "&:hover": {
      backgroundColor: "rgba(3, 105, 161, 0.12)",
      borderColor: info.focus,
      color: info.focus,
    },
  },
};

export default outlined;
